import { createAsyncThunk } from "@reduxjs/toolkit";
import AxiosClient from "../AxiosClient";
import AxiosClientForFile from "../AxiosClientForFile";
import { OMS_BASE } from "src/utils/constants";

// upload images
export const uploadUserGalleryAsync = createAsyncThunk(
  'userGallery/upload',
  async (formData: FormData, toolkit) => {
    const url = `${OMS_BASE}/user-gallery`;
    return await AxiosClientForFile('POST', url, formData, toolkit, {}
    )
  }
)

export const getUserGalleryAsync = createAsyncThunk(
  'userGallery/getAll',
  async (payload: { page?: number; limit?: number; search?: string }, toolkit) => {
    const url = `${OMS_BASE}/user-gallery?page=${payload.page || 1}&limit=${payload.limit || 10}&search=${payload.search || ''}`
    return await AxiosClient('GET', url, [], toolkit, [])
  }
)
export const deleteUserGalleryAsync = createAsyncThunk(
  'userGallery/delete',
  async (payload: { id: number }, toolkit) => {
    const url = `${OMS_BASE}/user-gallery/${payload.id}`
    return await AxiosClient('DELETE', url, [], toolkit, [])
  }
)

// product create upadte delete and image delete
export const createProductAsync = createAsyncThunk(
  "products/create",
  async (payload: any, toolkit) => {
    const url = `${OMS_BASE}/products`;
    return await AxiosClient("POST", url, payload, toolkit, {});
  }
);

export const updateProductAsync = createAsyncThunk(
  "products/update",
  async (
    payload: { id: number; data: any },
    toolkit
  ) => {
    const url = `${OMS_BASE}/products/${payload.id}`;
    return await AxiosClient("PUT", url, payload.data, toolkit, {});
  }
);

export const getEditProductAsync = createAsyncThunk(
  "products/delete",
  async (payload: { id: number }, toolkit) => {
    const url = `${OMS_BASE}/products/${payload.id}`;
    return await AxiosClient("GET", url, [], toolkit, []);
  }
);
export const deleteProductAsync = createAsyncThunk(
  "products/delete",
  async (payload: { id: number }, toolkit) => {
    const url = `${OMS_BASE}/products/${payload.id}`;
    return await AxiosClient("DELETE", url, [], toolkit, []);
  }
);

export const deleteProductImageAsync = createAsyncThunk(
  "products/deleteImage",
  async (payload: { productId: number; imageId: number }, toolkit
  ) => {
    const url = `${OMS_BASE}/products/${payload.productId}/image/${payload.imageId}`;
    return await AxiosClient("DELETE", url, [], toolkit, []);
  }
);

export const deleteVariantAsync = createAsyncThunk(
  "products/deleteVariant",
  async (payload: { productId: number; variantId: number; }, toolkit) => {
    const url = `${OMS_BASE}/products/${payload.productId}/variants/${payload.variantId}`;
    return await AxiosClient("DELETE", url, [], toolkit, []);
  }
);

/**
 * Bulk-delete OMS products and/or variants (same endpoint, context-dependent payload).
 * DELETE /oms/products/variants
 * Body: { product_ids: number[]; variant_ids: number[] }
 *   - Variant list (e.g. All Products tab): product_ids: [], variant_ids: selected variant IDs
 *   - Product list: product_ids: selected product IDs, variant_ids: []
 *   Only the relevant array is populated; the other is empty.
 */
export const deleteProductsAndVariantsBulkAsync = createAsyncThunk(
  "products/deleteProductsAndVariantsBulk",
  async (
    payload: { product_ids: number[]; variant_ids: number[] },
    toolkit
  ) => {
    const url = `${OMS_BASE}/products/variants`;
    return await AxiosClient("DELETE", url, payload, toolkit, []);
  }
);

// get vendors
export const getVendorsAsync = createAsyncThunk(
  "vendors/getAll",
  async (
    payload: { page?: number; limit?: number; sort_by?: string; order_by?: string; type?: string; search?: string },
    toolkit
  ) => {
    const { page = 1, limit = 10, sort_by = "desc", order_by = "id", type = "vendor", } = payload || {};
    const url = `${OMS_BASE}/vendors?sort_by=${sort_by}&order_by=${order_by}&type=${type}&page=${page}&limit=${limit}`;
    return await AxiosClient("GET", url, [], toolkit, []);
  }
);

// PRODUCT UPLOAD CSV
export const getUploadDataProductAsync = createAsyncThunk(
  "products/getUploadData",
  async (payload: { id: number, pag?: number, limit?: number }, toolkit) => {
    const url = `${OMS_BASE}/list-uploaded-product-file-info?platform_id=${payload.id}&page=${payload.pag || 1}&limit=${payload.limit || 10}`;
    return await AxiosClient("GET", url, [], toolkit, []);
  }
);

export const uploadProductCsvAsync = createAsyncThunk(
  'products/uploadProductCsvAsync',
  async (formData: FormData, toolkit) => {
    return await AxiosClientForFile('POST', `${OMS_BASE}/upload-product-file`, formData, toolkit, {}
    )
  }
)

// INVENTORY UPLOAD CSV
export const getUploadDataInventoryAsync = createAsyncThunk(
  'inventory/getUploadData',
  async (payload: { id: number; pag?: number; limit?: number }, toolkit) => {
    const url = `${OMS_BASE}/v1/list-uploaded-inventory-file-info?platform_id=${payload.id}&page=${payload.pag || 1}&limit=${payload.limit || 10}`;
    return await AxiosClient('GET', url, [], toolkit, []);
  }
);

export const uploadInventoryCsvAsync = createAsyncThunk(
  'inventory/uploadInventoryCsv',
  async (formData: FormData, toolkit) => {
    return await AxiosClientForFile('POST', `${OMS_BASE}/v1/upload-inventory-file`, formData, toolkit, {});
  }
);

// CUSTOM FIELD PRODUCT
export const getProductCustomFieldsAsync = createAsyncThunk(
  "productCustomFields/getAll",
  async (
    payload: { page?: number; limit?: number; sort_by?: string; order_by?: string; product_id: string; search?: string },
    toolkit
  ) => {
    const { page = 1, limit = 10, sort_by = "desc", order_by = "id", product_id = "", } = payload || {};
    const url = `${OMS_BASE}/products/${product_id}/custom-fields?page=${page}&limit=${limit}&sort_by=${sort_by}&order_by=${order_by}`;
    return await AxiosClient("GET", url, [], toolkit, []);
  }
);
export const getVariantCustomFieldsAsync = createAsyncThunk(
  "productCustomFields/getVariantCustomFieldsAsync",
  async (
    payload: { productId: number, variantId: number },
    toolkit
  ) => {
    const url = `${OMS_BASE}/product-variants/${payload.variantId}/custom-fields/${payload.productId}`;
    return await AxiosClient("GET", url, [], toolkit, []);
  }
);

// Product VARIANTS APIs
export const getInventoryDetailsAsync = createAsyncThunk(
  "inventoryDetails/getAll",
  async (payload: {
    page?: number; limit?: number; sort_by?: string; order_by?: string; variant_ids: string;
    search?: string, platform_id?: number
  }, toolkit) => {
    const { page = 1, limit = 10, sort_by = "desc", order_by = "id", variant_ids = "", platform_id = "" } = payload || {};

    const url = `${OMS_BASE}/inventory-details?page=${page}&limit=${limit}&sort_by=${sort_by}&order_by=${order_by}&variant_ids=${variant_ids}&platform_id=${platform_id}`;
    return await AxiosClient("GET", url, [], toolkit, []);
  }
);

export const getAllVariantsAsync = createAsyncThunk(
  "products/getAllVariants",
  async (payload: { id: number; platform_id?: number | string }, toolkit) => {
    const base = `${OMS_BASE}/products/${payload.id}/variants`;
    const url =
      payload.platform_id != null && payload.platform_id !== ''
        ? `${base}?platform_id=${payload.platform_id}`
        : base;
    return await AxiosClient("GET", url, [], toolkit, []);
  }
);

export const SaveVariantAsync = createAsyncThunk(
  "products/create",
  async (payload: { product_id: number, payload: any }, toolkit) => {
    const url = `${OMS_BASE}/products/${payload.product_id}/variants`;
    return await AxiosClient("POST", url, payload.payload, toolkit, {});
  }
);

// COLLECTION APIS
// get collections
export const getCollectionsAsync = createAsyncThunk(
  "collections/getAll",
  async (
    payload: { page?: number; limit?: number; search?: string, id?: string },
    toolkit
  ) => {
    const { page = 1, limit = 10, search = "", id = "" } = payload || {};
    const params = new URLSearchParams({ page: String(page), limit: String(limit), });
    if (search.trim()) {
      params.append("search", search.trim());
    }
    if (id) {
      params.append("id", id);
    }
    const url = `${OMS_BASE}/collections?${params.toString()}`;
    return await AxiosClient("GET", url, [], toolkit, []);
  }
);

export const createCollectionAsync = createAsyncThunk(
  "collections/create",
  async (payload: any, toolkit) => {
    const url = `${OMS_BASE}/collections`;
    return await AxiosClient("POST", url, payload, toolkit, {});
  })
export const updateCollectionAsync = createAsyncThunk(
  "collections/update",
  async (payload: { id: number; data: any }, toolkit) => {
    const url = `${OMS_BASE}/collections/${payload.id}`;
    return await AxiosClient("PUT", url, payload.data, toolkit, {});
  })
export const deleteCollectionAsync = createAsyncThunk(
  "collections/delete",
  async (payload: { id: number }, toolkit) => {
    const url = `${OMS_BASE}/collections/${payload.id}`;
    return await AxiosClient("DELETE", url, [], toolkit, {});
  })

// Custom fields for collection
export const getEditProductCustomFieldsAsync = createAsyncThunk(
  "productCustomFields/getAll",
  async (payload: { productId: number }, toolkit) => {
    const url = `${OMS_BASE}/products/${payload.productId}/custom-fields?limit=100&page=1&sort_by=asc&order_by=id`;
    return await AxiosClient("GET", url, [], toolkit, []);
  }
);

export const createProductCustomFieldAsync = createAsyncThunk(
  "productCustomFields/create",
  async (payload: { productId: number; data: any }, toolkit) => {
    const url = `${OMS_BASE}/products/${payload.productId}/custom-fields`;
    return await AxiosClient("POST", url, payload.data, toolkit, {});
  }
);

export const deleteProductCustomFieldAsync = createAsyncThunk(
  "productCustomFields/delete",
  async (payload: { productId: number; fieldId: number }, toolkit) => {
    const url = `${OMS_BASE}/products/${payload.productId}/custom-fields/${payload.fieldId}`;
    return await AxiosClient("DELETE", url, [], toolkit, {});
  }
);

// Option Names and Values APIs
export const getOptionNamesAsync = createAsyncThunk(
  "options/getNames",
  async (payload: { productId: number }, toolkit) => {
    const url = `${OMS_BASE}/products/${payload.productId}/options`;
    return await AxiosClient("GET", url, [], toolkit, []);
  })

export const createOptionNameAsync = createAsyncThunk(
  "options/createName",
  async (payload: { productId: number; data: any }, toolkit) => {
    const url = `${OMS_BASE}/products/${payload.productId}/options`;
    return await AxiosClient("POST", url, payload.data, toolkit, {});
  })

// image product delete in edit mode 
export const deleteProductImageInEditModeAsync = createAsyncThunk(
  "products/deleteImageInEditMode",
  async (payload: { productId: number; imageId: number }, toolkit) => {
    const url = `${OMS_BASE}/products/${payload.productId}/image/${payload.imageId}`;
    return await AxiosClient("DELETE", url, [], toolkit, []);
  }
)

// erp/adjust-variant-inventory
export const adjustVariantInventoryAsync = createAsyncThunk(
  "inventory/adjustVariantInventory",
  async (payload: { data: any }, toolkit) => {
    const url = `${OMS_BASE}/adjust-variant-inventory`;
    return await AxiosClient("POST", url, payload.data, toolkit, {});
  }
)

// custom fields variant
export const getCustomEditVariantCustomFieldsAsync = createAsyncThunk(
  "variantCustomFields/getCustomEditVariantCustomFieldsAsync",
  async (payload: { productId: number, variantId: number, page?: number, limit?: number, sort_by?: string, sort_order?: string }, toolkit) => {
    const url = `${OMS_BASE}/product-variants/${payload.variantId}/custom-fields?limit=${payload.limit || 100}&page=${payload.page || 1}&sort_by=${payload.sort_by || 'asc'}&order_by=id`;
    return await AxiosClient("GET", url, [], toolkit, []);
  }
);

export const createVariantCustomFieldAsync = createAsyncThunk(
  "variantCustomFields/create",
  async (payload: { variantId: number; data: any }, toolkit) => {
    const url = `${OMS_BASE}/product-variants/${payload.variantId}/custom-fields`;
    return await AxiosClient("POST", url, payload.data, toolkit, {});
  }
);

// listing api normal for grouped
export const getListingProductsAsync = createAsyncThunk(
  "listing/getProducts",
  async (payload: { platformId: number, page?: number, limit?: number, search_string?: string, sort_order?: string, sort_by?: string }, toolkit) => {
    const url = `/api/platform-products/${payload.platformId}?page=${payload.page || 1}&limit=${payload.limit || 10}&search_string=${payload.search_string || ''}&sort_order=${payload.sort_order}&sort_by=${payload.sort_by}`;
    return await AxiosClient("GET", url, [], toolkit, []);
  }
)

// category mapping api
export const getPlatformParentFieldDataCategoriesAsync = createAsyncThunk(
  "categories/getPlatformParentFieldDataCategoriesAsync",
  async (payload: { page: number, limit: number, sort_by?: string, sort_order?: string, order_by?: string }, toolkit) => {
    const url = `${OMS_BASE}/categories?page=${payload.page || 1}&limit=${payload.limit || 10}&sort_by=${payload.sort_by}&order_by=${payload.order_by}`;
    return await AxiosClient("GET", url, [], toolkit, []);
  })

export const getPlatformChildFieldDataCategoriesAsync = createAsyncThunk(
  "categories/getPlatformChildFieldDataCategoriesAsync",
  async (payload: { parentId: number, page: number, limit: number, sort_by?: string, sort_order?: string, order_by?: string }, toolkit) => {
    const url = `${OMS_BASE}/child-categories/${payload.parentId}?page=${payload.page || 1}&limit=${payload.limit || 10}&sort_by=${payload.sort_by}&order_by=${payload.order_by}`;
    return await AxiosClient("GET", url, [], toolkit, []);
  })

// Category APIs
export const createCategoryAsync = createAsyncThunk(
  "categories/create",
  async (payload: any, toolkit) => {
    const url = `${OMS_BASE}/categories`;
    return await AxiosClient("POST", url, payload, toolkit, {});
  })
export const updateCategoryAsync = createAsyncThunk(
  "categories/update",
  async (payload: { id: number; data: any }, toolkit) => {
    const url = `${OMS_BASE}/categories/${payload.id}`;
    return await AxiosClient("PUT", url, payload.data, toolkit, {});
  })
export const deleteCategoryAsync = createAsyncThunk(
  "categories/delete",
  async (payload: { id: number }, toolkit) => {
    const url = `${OMS_BASE}/categories/${payload.id}`;
    return await AxiosClient("DELETE", url, [], toolkit, {});
  })

export const getCategoryByIdAsync = createAsyncThunk(
  "categories/getById",
  async (payload: { id: number }, toolkit) => {
    const url = `${OMS_BASE}/categories?id=${payload.id}&be_original=true`;
    return await AxiosClient("GET", url, [], toolkit, []);
  })

// Product Listing ag Apis for column and listData
export const getListingAgProductsAsync = createAsyncThunk(
  "listing/getProducts",
  async (
    payload: {
      platformId: number; page?: number; limit?: number; search_string?: string; sort_order?: "ASC" | "DESC" | ""
      sort_by?: string; columns?: string[]; columnFilters?: { field: string; value: any; operator?: string }[];
    }, toolkit) => {
    const params = new URLSearchParams();
    params.append("page", String(payload.page ?? 1));
    params.append("limit", String(payload.limit ?? 10));
    if (payload.sort_by) {
      params.append("sort_by", payload.sort_by);
    }
    if (payload.sort_order) {
      params.append("sort_order", payload.sort_order);
    }
    if (payload.search_string) {
      params.append("search_string", payload.search_string);
    }
    const columns = payload.columns ?? ["name", "sku", "api_status", "created_at", "updated_at", "id", "total_available_quantity", "total_reserve_quantity", "isCreatedByCommercium", "total_variants",];

    columns.forEach((column) => {
      params.append("columns[]", column);
    });

    if (payload.columnFilters) {
      payload.columnFilters.forEach((filter) => {
        if (filter.value !== '' && filter.value !== null && filter.value !== undefined) {
          params.append(filter.field, String(filter.value));
          if (filter.operator) {
            params.append(`${filter.field}_operator`, filter.operator);
          }
        }
      });
    }

    const url = `/api/platform-products-ag-grid/${payload.platformId}?${params.toString()}`;

    return await AxiosClient("GET", url, [], toolkit, []);
  }
);

export const getAgProductColumnsAsync = createAsyncThunk(
  "listing/getProductColumns",
  async (
    payload: { platformId: number; page?: number; limit?: number; }, toolkit) => {
    const url = `/api/platform-product-columns/${payload.platformId}?page=${payload.page || 1}&limit=${payload.limit || 10}`;

    return await AxiosClient("GET", url, [], toolkit, []);
  }
);